<script setup lang="ts">

import { Backgrounds, usePresentation } from '@presentation/Types';
import { PRICES } from '@presentation/Types/Settings';

const presentation = usePresentation();
presentation.backgroundImage = Backgrounds.Four;

</script>

<template>

    <Page>
    
        <ImageAndText 
            animation="zoom"
            src="/DealerProposition/early-bird-discount-smooth.png"
            image-class="drop-shadow-2xl scale-125 3xl:scale-[175%] translate-x-[50%] mt-6">

            <h2 class="mt-8 uppercase text-2xl">Early Birds - Limited Time Offer!</h2>
            
            <h2 class="mb-4 mt-2 font-semibold">
                Join Carbucks Before May 1st and Get      
            </h2>

            <ul class="mt-3 list-disc font-semibold text-white">
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>Unlimited App Installs &amp; Downloads</div>
                    <div class="opacity-60 font-normal">Every customer, every device - no limits</div>
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>$0 Set-up Fee, all rooftops</div>
                    <div class="opacity-60 font-normal">Normally ${{ PRICES.Subscription.toLocaleString() }} per rooftop - waived!</div>
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>First 30 Days <span class="text-emerald-500 font-semibold">FREE</span></div>
                    <div class="opacity-60 font-normal">Get started with no up-front costs</div>
                </li>
                <li class="pl-2 ml-5 mb-2 2xl:mb-4">
                    <div>Strictly limited offer</div>
                    <div class="opacity-60 font-normal">Available to the first 10 customers only</div>
                </li>
            </ul>

        </ImageAndText>

        <KeyMessage>
            <span>
                Don't <span class="text-white">miss out!</span>
            </span>
        </KeyMessage>

    </Page>

</template>